import { defineMessages } from '../translate';

/** App frame: root route, not-found / error pages, desktop shell, live toasts. */
export default defineMessages('shell', {
  // Boot
  connecting: 'Connecting to Projoint…',
  stalled: "Can't reach Projoint right now — still trying…",
  signInAgain: 'Sign in again',
  // Not found / error pages
  notFoundTitle: "We couldn't find that page",
  notFoundBody:
    'The link may be broken, the resource may have been moved or deleted, or you may not have access.  If you expected to see something here, ask the team owner to share it with you.',
  goToHome: 'Go to Home',
  errorTitle: 'Something went wrong',
  errorBody:
    "We've logged the error and are looking into it.  Try refreshing the page — most one-off blips clear themselves.  If it keeps happening, drop us a note from the contact page.",
  goHome: 'Go home',
  technicalDetails: 'Technical details',
  // Task by id
  couldntOpenTask: "Couldn't open this task.",
  openingTask: 'Opening task',
  noTaskAccess: 'No access to this task',
  noTaskAccessBody: 'It might be in a team you’re not in, or has been deleted.',
  pickTaskFirst: 'Pick a task first',
  pickTaskFirstBody: 'Focus a task row (Tab) or open a task, then press T.',
  // Notifications bell
  notifications: 'Notifications',
  notificationsUnread: 'Notifications, {count} unread',
  unreadCount: '{count} unread',
  markAllRead: 'Mark all read',
  allCaughtUp: "You're all caught up.",
  allCaughtUpBody: 'New mentions, assignments and replies land here.',
  openInbox: 'Open inbox',
  unread: 'Unread',
  newNotification: 'New notification',
} as const);
